import { render } from "./mobileExamination.vue?vue&type=template&id=6de40a1a&scoped=true"
import script from "./mobileExamination.vue?vue&type=script&lang=js"
export * from "./mobileExamination.vue?vue&type=script&lang=js"

import "./mobileExamination.vue?vue&type=style&index=0&id=6de40a1a&lang=less&scoped=true"

import exportComponent from "/Users/user/mscode/tecs/TECS-FE-ENDUSER-NEW/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de40a1a"]])

export default __exports__